import Chart from "react-apexcharts";
import InvestmentValueChart from "./InvestmentValueChart";
import AnalyticsStore from "../../../../store/AnalyticsStore";
import EmptyScreen from "../../Equity/EmptyScreen/EmptyScreen";
import { formatDateToLocaleDateString } from "../../../../utils/functions";

const InvestmentValue = ({
  investmentData,
  investmentValue,
  investmentType,
  currentValue,
  currentType,
  graphData,
}) => {
  // const [investmentData, setInvestmentData] = useState([]);
  // const [investmentValue, setInvestmentValue] = useState("");
  // const [investmentType, setInvestmentType] = useState("");
  // const [currentValue, setCurrentValue] = useState("");
  // const [currentType, setCurrentType] = useState("");

  //let categoriesData = [];

  // const isPrimary =
  //   (AnalyticsStore?.overall?.isPrimary ||
  //     JSON.parse(getCookie("isPrimary"))) &&
  //   UserStore.getData === "fam"
  //     ? true
  //     : false;
  // const userId =
  //   !isPrimary && (AnalyticsStore?.overall?.userId || getCookie("userid"));

  // useEffect(() => {
  //   let graphValue = [];
  //   let familyId = UserStore?.userData?.family_id;
  //   if (familyId) {
  //     setCookie("familyId", familyId);
  //   } else {
  //     familyId = getCookie("familyId");
  //   }
  //   AnalyticsStore.setOverall({
  //     ...AnalyticsStore.overall,
  //     investmentValue: [],
  //     investmentLoading: true,
  //   });
  //   getInvestmentValue(familyId, userId).then((response) => {
  //     setInvestmentValue(
  //       `${commaSeperated2(
  //         response.data[0]?.investmentReturn?.invested_value.value
  //       )}`
  //     );
  //     setInvestmentType(
  //       displayUnit(
  //         response.data[0]?.investmentReturn.invested_value.value_type
  //       )
  //     );
  //     setCurrentValue(
  //       `${commaSeperated2(
  //         response.data[0]?.investmentReturn.current_value.value
  //       )} `
  //     );
  //     setCurrentType(
  //       displayUnit(response.data[0]?.investmentReturn.current_value.value_type)
  //     );

  //     let investmentObj = {
  //       name: "Investment Value",
  //     };

  //     let currentObj = {
  //       name: "Current Value",
  //     };

  //     let investmentData = [];
  //     let currentData = [];

  //     response.data[0]?.investmentReturnTimelines.map((item) => {
  //       investmentData.push(item.modelCategory?.invested_value?.value);
  //       currentData.push(item.modelCategory?.current_value?.value);
  //       categoriesData.push(
  //         moment(item.date, "YYYY-MM-DD").format("DD MMM YYYY")
  //       );
  //       return false;
  //     });

  //     investmentObj["data"] = investmentData;
  //     currentObj["data"] = currentData;

  //     graphValue.push(investmentObj);
  //     graphValue.push(currentObj);

  //     graphValue.push();
  //     AnalyticsStore.setOverall({
  //       ...AnalyticsStore.overall,
  //       investmentCategories: categoriesData,
  //     });
  //     AnalyticsStore.setOverall({
  //       ...AnalyticsStore.overall,
  //       investmentValue: response.data,
  //       investmentLoading: false,
  //     });
  //     setInvestmentData(response?.data?.length ? graphValue : []);
  //   });
  //   return () => {
  //     setInvestmentData([]);
  //   };
  //   // eslint-disable-next-line
  // }, [userId]);

  let investmentValueChartObject = new InvestmentValueChart();

  return (
    <>
      <h2 className="performers asset_allocation_text">
        <b>Investment Value</b> vs Current Value Over Time
      </h2>
      {investmentData.length > 0 &&
      AnalyticsStore.overall.investmentValue.length ? (
        <>
          <div className="investment_value_label">
            <div>
              <div className="investment__value__section">
                <div
                  className="area_chart_labels"
                  style={{ backgroundColor: "#034DA2" }}
                />
                <p style={{ color: "#060F1F;" }}>Investment Value</p>
              </div>
              <div style={{ marginTop: "10px" }}>
                <h2 className="investment_value_invest">
                  <span
                    style={{
                      fontWeight: 700,
                      fontFamily: "Roboto",
                    }}
                  >
                    {investmentValue}
                  </span>{" "}
                  <span
                    style={{
                      fontFamily: "Encode Sans",
                      fontWeight: 700,
                      textTransform: "capitalize",
                    }}
                  >
                    {investmentType}
                  </span>{" "}
                </h2>
              </div>
            </div>
            <div>
              <div className="investment__value__section">
                <div
                  className="area_chart_labels"
                  style={{ backgroundColor: "#C59331" }}
                />
                <p style={{ color: "#060F1F;" }}>Current Value</p>
              </div>
              <div style={{ marginTop: "10px" }}>
                <h2 className="investment_value_current">
                  <span
                    style={{
                      fontWeight: 700,
                      fontFamily: "Roboto",
                    }}
                  >
                    {currentValue}
                  </span>{" "}
                  <span
                    style={{
                      fontFamily: "Encode Sans",
                      fontWeight: 700,
                      textTransform: "capitalize",
                    }}
                  >
                    {currentType}
                  </span>{" "}
                </h2>
              </div>
            </div>
          </div>
          <div
            className="investment_chart_div"
            style={{ width: "100%", height: "400px", padding: "0px" }}
            role="img"
            aria-label="Investment value vs Current value trend over time"
            tabIndex={0}
          >
            <Chart
              style={{ innerHeight: "fit-content" }}
              options={investmentValueChartObject.state.options}
              series={investmentData}
              type="area"
              height="400px"
            />
          </div>

          <table id={"chart-table"} className="chart-table-sr-only">
            <caption>Investment value vs Current value trend over time</caption>

            <thead>
              <tr>
                <th scope="col">Date</th>
                <th scope="col">Investment Value</th>
                <th scope="col">Current Value</th>
              </tr>
            </thead>

            <tbody>
              {graphData?.map((item, index) => (
                <tr key={index}>
                  <td>
                    {formatDateToLocaleDateString({ dateStr: item.date })}
                  </td>
                  <td>
                    {item.modelCategory?.invested_value?.value}
                    {item.modelCategory?.invested_value?.value_type}
                  </td>
                  <td>
                    {item.modelCategory?.current_value?.value}
                    {item.modelCategory?.current_value?.value_type}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : (
        <EmptyScreen
          loading={
            AnalyticsStore.overall.investmentLoading ||
            AnalyticsStore.overall.investmentValue.length > 0
          }
        />
      )}
    </>
  );
};

export default InvestmentValue;
